import { STOP_WORDS } from '../../public/js/nlp/data/stopWords.js';

export function analyzeText(text) {
    if (!text || text.trim().length === 0) {
        return { words: 0, characters: 0, charactersNoSpaces: 0, sentences: 0, readingTime: 0, keywords: [] };
    }

    const words = text.trim().split(/\s+/).filter(Boolean);
    const wordCount = words.length;
    const charCount = text.length;
    const charNoSpaces = text.replace(/\s/g, '').length;
    const sentenceCount = (text.match(/[.!?]+(\s|$)/g) || []).length;
    const readingTime = Math.ceil(wordCount / 200); // 200 WPM average
    
    const freq = {};
    words.forEach(w => {
        const clean = w.toLowerCase().replace(/[^a-z0-9+#.-]/g, "");
        if (clean && clean.length > 2 && !STOP_WORDS.has(clean)) {
            freq[clean] = (freq[clean] || 0) + 1;
        }
    });

    const keywords = Object.entries(freq)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10)
        .map(([word, count]) => ({ word, count, density: ((count / wordCount) * 100).toFixed(2) }));

    return { words: wordCount, characters: charCount, charactersNoSpaces: charNoSpaces, sentences: sentenceCount, readingTime, keywords };
}
